import React from "react";
import { Link } from "react-router-dom";
import { Calendar, User, ArrowLeft } from "lucide-react";
import { fileUrl } from "@/lib/api";

export const ArticleCard = ({ article }) => {
  return (
    <Link
      to={`/articles/${article.id}`}
      data-testid={`article-card-${article.id}`}
      className="card-hover bg-white rounded-xl overflow-hidden border border-amber-200/60 shadow-sm flex flex-col group"
    >
      <div className="relative aspect-[16/10] bg-slate-100 overflow-hidden">
        {article.image_url ? (
          <img src={fileUrl(article.image_url)} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-amber-100 to-amber-50 text-amber-400">
            <i className="fa-solid fa-feather-pointed text-4xl" />
          </div>
        )}
        {article.category && (
          <span className="absolute top-3 left-3 bg-[#0a2540] text-white text-xs px-2.5 py-1 rounded-full">
            {article.category}
          </span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-4 text-xs text-slate-500 mb-2">
          {article.author && <span className="flex items-center gap-1"><User size={12} /> {article.author}</span>}
          {article.date && <span className="flex items-center gap-1"><Calendar size={12} /> {article.date}</span>}
        </div>
        <h3 className="font-serif-deva text-xl text-[#0a2540] leading-snug line-clamp-2 group-hover:text-amber-700 transition-colors">
          {article.title}
        </h3>
        {article.summary && <p className="text-sm text-slate-600 mt-2 line-clamp-3 flex-1">{article.summary}</p>}
        <span className="text-amber-700 text-sm font-medium mt-4 flex items-center gap-1">
          पूरा पढ़ें <ArrowLeft size={14} className="rotate-180" />
        </span>
      </div>
    </Link>
  );
};
